module.exports = __webpack_public_path__ + "static/media/mollo_1.8fbe5d84.png";